export const listSVGIcon04 = {
  'user-white': (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18C20 15.34 14.67 14 12 14Z"
        fill="#fff"
      />
    </svg>
  ),
  BHSicon: (
    <svg
      width="166"
      height="40"
      viewBox="0 0 166 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2268_825)">
        <path
          d="M56.564 0H77.4918C85.4068 0 89.6852 1.49353 87.376 10.2393C86.0362 15.3071 84.154 18.6132 78.6738 19.4666L78.5604 19.8933C84.3584 20.2652 84.4294 23.8394 83.0998 28.8524C80.5072 38.665 75.5876 40 67.1404 40H46L56.564 0ZM62.9592 16H70.609C74.3266 16 75.3994 15.3599 76.2452 12.1595C76.8788 9.75972 76.7472 8.85344 73.8006 8.74574H64.8858L62.9592 16ZM58.9298 31.2542H66.952C70.4046 31.2542 72.0498 30.4536 72.91 27.2004C73.7842 23.8944 72.6874 23.4128 69.237 23.4128H61.0042L58.9298 31.2542Z"
          fill="#008CCA"
        />
        <path
          d="M119.824 40H109.589L113.579 24.319H100.225L96.2348 40H86L96.1804 0H106.413L102.586 15.0368H115.94L119.767 0H130L119.824 40Z"
          fill="#008CCA"
        />
        <path
          d="M150.832 15.7456C162.141 16.5857 164.612 18.0558 162.242 27.0848C160.534 33.5934 159.113 40 141.975 40C132.056 40 125.514 39.8 128.903 26.8746H138.874C137.8 30.969 139.144 31.3892 144.235 31.3892C149.117 31.3892 150.81 31.0752 151.677 27.7668C152.573 24.3544 151.988 24.4064 147.187 24.0924L144.943 23.9344C135.515 23.2524 129.891 23.3044 132.853 12.0172C135.815 0.730081 142.294 0 152.472 0C160.981 0 168.219 0.158018 165.368 11.0251L164.941 12.6513H154.97C156.03 8.60886 154.376 8.60886 150.221 8.60886C144.611 8.60886 143.841 9.76498 143.263 11.9692C142.436 15.1195 143.914 15.2235 146.613 15.4335L150.832 15.7456Z"
          fill="#008CCA"
        />
        <path
          d="M36.4062 10L30.2784 31.2012H10.539L8 40H39.3394L48 10H36.4062Z"
          fill="#F77E0B"
        />
        <path
          d="M37.461 8.7988L40 0H8.66054L0 30H11.5998L17.7275 8.7988H37.461Z"
          fill="#008CCA"
        />
        <path d="M30 14H20.8412L18 26H27.1588L30 14Z" fill="#008CCA" />
      </g>
      <defs>
        <clipPath id="clip0_2268_825">
          <rect width="166" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  BHSmetaicon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.4062 10L30.2784 31.2012H10.539L8 40H39.3394L48 10H36.4062Z"
        fill="#F77E0B"
      />
      <path
        d="M37.461 8.7988L40 0H8.66054L0 30H11.5998L17.7275 8.7988H37.461Z"
        fill="#008CCA"
      />
      <path d="M30 14H20.8412L18 26H27.1588L30 14Z" fill="#008CCA" />
    </svg>
  ),
  txt: (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 32 32"
      height="200px"
      width="200px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 6 3 L 6 29 L 26 29 L 26 9.5996094 L 25.699219 9.3007812 L 19.699219 3.3007812 L 19.400391 3 L 6 3 z M 8 5 L 18 5 L 18 11 L 24 11 L 24 27 L 8 27 L 8 5 z M 20 6.4003906 L 22.599609 9 L 20 9 L 20 6.4003906 z M 10 13 L 10 15 L 22 15 L 22 13 L 10 13 z M 10 18 L 10 20 L 17 20 L 17 18 L 10 18 z M 19 18 L 19 20 L 22 20 L 22 18 L 19 18 z M 10 22 L 10 24 L 17 24 L 17 22 L 10 22 z M 19 22 L 19 24 L 22 24 L 22 22 L 19 22 z"></path>
    </svg>
  ),
  pdf: (
    <svg
      height="800px"
      width="800px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 309.267 309.267"
      xmlSpace="preserve"
    >
      <g>
        <path
          style={{ fill: '#E2574C' }}
          d="M38.658,0h164.23l87.049,86.711v203.227c0,10.679-8.659,19.329-19.329,19.329H38.658
		c-10.67,0-19.329-8.65-19.329-19.329V19.329C19.329,8.65,27.989,0,38.658,0z"
        />
        <path
          style={{ fill: '#B53629' }}
          d="M289.658,86.981h-67.372c-10.67,0-19.329-8.659-19.329-19.329V0.193L289.658,86.981z"
        />
        <path
          style={{ fill: '#ffffff' }}
          d="M217.434,146.544c3.238,0,4.823-2.822,4.823-5.557c0-2.832-1.653-5.567-4.823-5.567h-18.44
		c-3.605,0-5.615,2.986-5.615,6.282v45.317c0,4.04,2.3,6.282,5.412,6.282c3.093,0,5.403-2.242,5.403-6.282v-12.438h11.153
		c3.46,0,5.19-2.832,5.19-5.644c0-2.754-1.73-5.49-5.19-5.49h-11.153v-16.903C204.194,146.544,217.434,146.544,217.434,146.544z
		 M155.107,135.42h-13.492c-3.663,0-6.263,2.513-6.263,6.243v45.395c0,4.629,3.74,6.079,6.417,6.079h14.159
		c16.758,0,27.824-11.027,27.824-28.047C183.743,147.095,173.325,135.42,155.107,135.42z M155.755,181.946h-8.225v-35.334h7.413
		c11.221,0,16.101,7.529,16.101,17.918C171.044,174.253,166.25,181.946,155.755,181.946z M106.33,135.42H92.964
		c-3.779,0-5.886,2.493-5.886,6.282v45.317c0,4.04,2.416,6.282,5.663,6.282s5.663-2.242,5.663-6.282v-13.231h8.379
		c10.341,0,18.875-7.326,18.875-19.107C125.659,143.152,117.425,135.42,106.33,135.42z M106.108,163.158h-7.703v-17.097h7.703
		c4.755,0,7.78,3.711,7.78,8.553C113.878,159.447,110.863,163.158,106.108,163.158z"
        />
      </g>
    </svg>
  ),
  docx: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36">
      <path
        fill="#fff"
        d="M11.386 33H32.6c.216 0 .4-.17.4-.372V10h-5.6c-.772 0-1.4-.628-1.4-1.4V3H11.4c-.216 0-.4.17-.4.372v29.27c0 .197.173.358.386.358z"
      />
      <path fill="#fff" d="M32.204 9 27 3.815V8.6c0 .22.18.4.4.4h4.804z" />
      <path
        fill="#605E5C"
        fillRule="evenodd"
        d="m33.613 8.993-6.595-6.572A1.45 1.45 0 0 0 26 2H11.4c-.772 0-1.4.615-1.4 1.372v29.27c0 .749.622 1.358 1.386 1.358H32.6c.772 0 1.4-.615 1.4-1.372V9.923c0-.346-.14-.686-.387-.93zM27 3.815 32.204 9H27.4a.4.4 0 0 1-.4-.4V3.815zM32.6 33c.216 0 .4-.17.4-.372V10h-5.6c-.772 0-1.4-.628-1.4-1.4V3H11.4c-.216 0-.4.17-.4.372v29.27c0 .198.173.358.386.358H32.6z"
        clipRule="evenodd"
        opacity=".64"
      />
      <path fill="#103F91" d="M29.5 24H20v1h9.5a.5.5 0 0 0 0-1z" />
      <path fill="#185ABD" d="M29.5 21H20v1h9.5a.5.5 0 0 0 0-1z" />
      <path fill="#2B7CD3" d="M29.5 18H20v1h9.5a.5.5 0 0 0 0-1z" />
      <path fill="#41A5EE" d="M29.5 15H20v1h9.5a.5.5 0 0 0 0-1z" />
      <path
        fill="#185ABD"
        d="M3.5 28h13a1.5 1.5 0 0 0 1.5-1.5v-13a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 2 13.5v13A1.5 1.5 0 0 0 3.5 28z"
      />
      <path
        fill="#F9F7F7"
        d="M7.857 22.55h.027c.01-.134 1.358-6.55 1.358-6.55H10.8s1.378 6.118 1.42 6.538h.02c.018-.29 1.134-6.538 1.134-6.538H14.8l-1.755 8h-1.666s-1.384-6.32-1.395-6.432h-.02c-.014.13-1.3 6.432-1.3 6.432H6.968L5.2 16h1.452s1.2 6.408 1.207 6.55z"
      />
    </svg>
  ),
  xlsx: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36">
      <path
        fill="#fff"
        d="M11.386 33H32.6c.216 0 .4-.17.4-.372V10h-5.6c-.772 0-1.4-.628-1.4-1.4V3H11.4c-.216 0-.4.17-.4.372v29.27c0 .197.173.358.386.358z"
      />
      <path fill="#fff" d="M32.204 9 27 3.815V8.6c0 .22.18.4.4.4h4.804z" />
      <path
        fill="#605E5C"
        fillRule="evenodd"
        d="m33.613 8.993-6.595-6.572A1.45 1.45 0 0 0 26 2H11.4c-.772 0-1.4.615-1.4 1.372v29.27c0 .749.622 1.358 1.386 1.358H32.6c.772 0 1.4-.615 1.4-1.372V9.923c0-.346-.14-.686-.387-.93zM27 3.815 32.204 9H27.4a.4.4 0 0 1-.4-.4V3.815zM32.6 33c.216 0 .4-.17.4-.372V10h-5.6c-.772 0-1.4-.628-1.4-1.4V3H11.4c-.216 0-.4.17-.4.372v29.27c0 .198.173.358.386.358H32.6z"
        clipRule="evenodd"
        opacity=".64"
      />
      <path fill="#134A2C" d="M29 25h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2z" />
      <path fill="#185C37" d="M23 25h-3v-2h3a1 1 0 1 1 0 2z" />
      <path fill="#21A366" d="M29 21h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2z" />
      <path fill="#107C41" d="M23 21h-3v-2h3a1 1 0 1 1 0 2z" />
      <path fill="#33C481" d="M29 17h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2z" />
      <path fill="#21A366" d="M23 17h-3v-2h3a1 1 0 1 1 0 2z" />
      <path
        fill="#107C41"
        d="M3.5 28h13a1.5 1.5 0 0 0 1.5-1.5v-13a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 2 13.5v13A1.5 1.5 0 0 0 3.5 28z"
      />
      <path
        fill="#F9F7F7"
        d="m6 25 2.898-5.013L6.243 15h2.136l1.449 3.186c.133.303.225.529.275.677h.02c.095-.242.194-.476.299-.705L11.97 15h1.96l-2.723 4.959L14 25h-2.086l-1.674-3.5a3.11 3.11 0 0 1-.2-.469h-.025c-.03.112-.093.264-.193.454L8.1 25H6z"
      />
    </svg>
  ),
  pptx: (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 36 36">
      <path
        fill="#fff"
        d="M11.386 33H32.6c.216 0 .4-.17.4-.372V10h-5.6c-.772 0-1.4-.628-1.4-1.4V3H11.4c-.216 0-.4.17-.4.372v29.27c0 .197.173.358.386.358z"
      />
      <path fill="#fff" d="M32.204 9 27 3.815V8.6c0 .22.18.4.4.4h4.804z" />
      <path
        fill="#605E5C"
        fillRule="evenodd"
        d="m33.613 8.993-6.595-6.572A1.45 1.45 0 0 0 26 2H11.4c-.772 0-1.4.615-1.4 1.372v29.27c0 .749.622 1.358 1.386 1.358H32.6c.772 0 1.4-.615 1.4-1.372V9.923c0-.346-.14-.686-.387-.93zM27 3.815 32.204 9H27.4a.4.4 0 0 1-.4-.4V3.815zM32.6 33c.216 0 .4-.17.4-.372V10h-5.6c-.772 0-1.4-.628-1.4-1.4V3H11.4c-.216 0-.4.17-.4.372v29.27c0 .198.173.358.386.358H32.6z"
        clipRule="evenodd"
        opacity=".64"
      />
      <path
        fill="#ED6C47"
        d="M23.965 20.035 23 19h-2l-1 1v4.463A5.971 5.971 0 0 0 24.001 26 6 6 0 0 0 30 20.035h-6.035z"
      />
      <path fill="#FFC7B5" d="M25 13v6h6a6 6 0 0 0-6-6z" />
      <path fill="#FF8F6B" d="M20 15.554V20h4v-6a6.013 6.013 0 0 0-4 1.554z" />
      <path
        fill="#C43E1C"
        d="M3.5 28h13a1.5 1.5 0 0 0 1.5-1.5v-13a1.5 1.5 0 0 0-1.5-1.5h-13A1.5 1.5 0 0 0 2 13.5v13A1.5 1.5 0 0 0 3.5 28z"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13.224 15.785c-.577-.524-1.411-.785-2.497-.785H7.102v9.784H8.88v-3.46h1.73c.696 0 1.306-.137 1.833-.413a2.95 2.95 0 0 0 1.219-1.155c.285-.497.428-1.063.428-1.7 0-.991-.288-1.748-.866-2.271zm-2.815 4.045h-1.53v-3.315h1.587c1.168 0 1.752.539 1.752 1.616 0 .556-.153.977-.457 1.266-.305.289-.755.433-1.352.433z"
        clipRule="evenodd"
      />
    </svg>
  ),
};
